// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".comment-feed-item[data-v-676efc06]{margin-top:1em}\n", "",{"version":3,"sources":["CommentFeedBasic.vue"],"names":[],"mappings":"AA4FA,oCACE,cAAe","file":"CommentFeedBasic.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.comment-feed-item {\n  margin-top: 1em;\n}\n"]}]);
// Exports
module.exports = exports;
